import { render, staticRenderFns } from "./BriefExplanation.vue?vue&type=template&id=857065a6&"
import script from "./BriefExplanation.vue?vue&type=script&lang=js&"
export * from "./BriefExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports